<template>
    <v-container align-start>
        <v-form
            class="form-pwd"
            v-model="valid"
            ref="form"
            @submit.native.prevent="next"
        >
            <v-layout>
                <v-flex xs12>
                    <v-text-field
                        v-model="password"
                        solo
                        :label="lang.password_placeholder"
                        :disabled="pageLoading"
                        :readonly="sending"
                        :type="showPwd ? 'text' : 'password'"
                        :rules="rules"
                        :append-icon="
                            showPwd ? 'fas fa-eye' : 'fas fa-eye-slash'
                        "
                        @click:append="showPwd = !showPwd"
                    ></v-text-field>
                </v-flex>
            </v-layout>
            <verification-code
                v-model="code"
                :disabled="!isPwdValid || isErrValue"
                :params="{}"
                :error="isErrCode"
                type="image"
                @send="v => (sending = v)"
            ></verification-code>
            <v-btn
                block
                :disabled="!valid"
                class="btn-h48"
                color="primary"
                @click="next"
            >
                {{ lang.next_step_text }}
            </v-btn>
        </v-form>
    </v-container>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import VerificationCode from "@/components/VerificationCode";
export default {
    name: "Password",
    components: {
        VerificationCode
    },
    data() {
        return {
            valid: false,
            showPwd: false,
            sending: false,
            password: "",
            code: "",
            isErrValue: false,
            isErrCode: false
        };
    },
    computed: {
        ...mapState(["pageLoading", "params"]),
        ...mapGetters(["lang"]),
        isPwdValid() {
            return this.password.length >= 6;
        },
        rules() {
            let tmp = [];
            tmp.push(v => !v && this.lang.empty_password_tips);
            tmp.push(() => this.isPwdValid || this.lang.empty_password_tips);
            tmp.push(
                () => this.isErrValue && this.lang.iscorrect_password_tips
            );
            return tmp;
        }
    },
    watch: {
        password() {
            this.isErrValue = false;
        },
        code(val) {
            if (val) {
                this.isErrCode = false;
            }
        }
    },
    methods: {
        ...mapActions(["verifyPwdFPTS"]),
        ...mapMutations({
            changePageLoading: "CHANGE_PAGE_LOADING",
            changeAuthVerified: "CHANGE_AUTH_VERIFIED"
        }),
        next() {
            if (this.pageLoading) {
                return;
            }
            this.changePageLoading(true);
            this.verifyPwdFPTS({
                password: this.password,
                captcha: this.code
            })
                .then(() => {
                    this.changeAuthVerified("password");
                    this.$router.push({
                        name: this.$route.query.redirect,
                        query: Object.assign({}, this.params, {
                            t: Date.now()
                        })
                    });
                })
                .catch(err => {
                    if (err.code === 1001) {
                        this.isErrCode = true;
                    } else if (err.code === 1002) {
                        this.isErrCode = true;
                        this.isErrValue = true;
                    }
                    setTimeout(() => {
                        this.changePageLoading(false);
                        this.$refs.form.validate();
                    }, 300);
                });
        }
    }
};
</script>
